import { render, staticRenderFns } from "./WhatsappMessages.vue?vue&type=template&id=6e404694"
import script from "./WhatsappMessages.vue?vue&type=script&lang=js"
export * from "./WhatsappMessages.vue?vue&type=script&lang=js"
import style0 from "./WhatsappMessages.vue?vue&type=style&index=0&id=6e404694&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports